/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var PathMarkupToken = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PathMarkupToken, _super);
    function PathMarkupToken(a, b) {
        var _this = _super.call(this) || this;
        _this.c = 0;
        _this.a = false;
        _this.b = 0;
        _this.c = a;
        _this.a = b;
        return _this;
    }
    PathMarkupToken.$t = markType(PathMarkupToken, 'PathMarkupToken');
    return PathMarkupToken;
}(Base));
export { PathMarkupToken };
//# sourceMappingURL=PathMarkupToken.js.map
